import { useMemo, useState } from "react";
import {useAppSelector} from "hooks/useAppSelector";

export const useTwoAuthVerificationData = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [verified, setIsVerified] = useState(false);

    const googleAutoCryptoState = useAppSelector((state) => state.user.user?.googleAutoCryptoState);

    const isOpenGoogleAutoCrypto = useMemo(() => {
        return googleAutoCryptoState === 0;
    }, [googleAutoCryptoState]);

    return {
        isModalOpen,
        setIsModalOpen,
        verified,
        setIsVerified,
        isOpenGoogleAutoCrypto,
    }
}